<template>
  <div class="promocode-processing">
    <SDialog v-model:open="modalVisible">
      <SDialogContent
        class="promocode-processing !w-[600px] !max-w-[600px]"
        :show-close-button="false"
        @escape-key-down.prevent
        @pointer-down-outside.prevent
        @open-auto-focus.prevent
      >
        <SDialogHeader>
          <SDialogTitle class="sr-only">
            {{ $t("promocode.processing-order") }}
          </SDialogTitle>
        </SDialogHeader>
        <div class="d-flex flex-column fl-a-c fl-j-c">
          <p class="processing-order">{{ $t("promocode.processing-order") }}</p>
          <LoaderCircleIcon class="s-icon-spin spinner" />
          <div class="mb-5" style="text-align: center">
            {{ message }}
          </div>
        </div>
      </SDialogContent>
    </SDialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import i18n from "@/lang";
import { LoaderCircleIcon } from "@smeetz/ui-icons";
import {
  SDialog,
  SDialogContent,
  SDialogHeader,
  SDialogTitle,
} from "@smeetz/ui-core";
// Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on t()
const t: (key: string, ...args: unknown[]) => string = (i18n.global as any).t;

export default defineComponent({
  name: ModalComponents.PromocodeProcessing,
  components: {
    LoaderCircleIcon,
    SDialog,
    SDialogContent,
    SDialogHeader,
    SDialogTitle,
  },
  setup() {
    const modalVisible = dialogVisibleForStatus(
      ModalStatus.PromocodeProcessing
    );
    const message = ref(t("promocode.processing-promocode"));
    onMounted(() => {
      // update message if syncing takes more than 10 seconds
      setTimeout(() => {
        message.value = t("promocode.taking-long");
      }, 10000);
    });
    return { modalVisible, message };
  },
});
</script>

<style lang="scss">
@use "@/styles/variables.scss" as *;
.promocode-processing {
  p {
    font-size: 22px;
    font-weight: bold;
  }

  .spinner {
    font-size: 60px;
    color: $color-dark-cyan;
  }
}
</style>
